import { ContactCard } from './ContactCard';
import { EmailTypeCell } from './EmailTypeCell';
import styles from './ExtranetContacts.module.scss';
import { EMAIL_TYPE_COLUMNS } from './columns';
import type { EmailTypeKey, ExtranetContact } from './columns';

type ContactRowProps = {
  isEditMode: boolean;
  displayIndex: number;
  namePath: number;
  contact?: ExtranetContact;
  checkedCounts: Record<EmailTypeKey, number>;
  onRemove?: () => void;
  canRemove?: boolean;
};

export const ContactRow = ({
  isEditMode,
  displayIndex,
  namePath,
  contact,
  checkedCounts,
  onRemove,
  canRemove,
}: ContactRowProps) => (
  <div className={styles.row}>
    <ContactCard
      isEditMode={isEditMode}
      displayIndex={displayIndex}
      namePath={namePath}
      onRemove={onRemove}
      canRemove={canRemove ?? false}
    />
    {EMAIL_TYPE_COLUMNS.map((column) => (
      <EmailTypeCell
        key={column.key}
        isEditMode={isEditMode}
        namePath={namePath}
        column={column}
        checked={Boolean(contact?.[column.key])}
        checkedCount={checkedCounts[column.key]}
      />
    ))}
  </div>
);
